import { Usuario } from 'src/app/models/usuario/usuario.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class ConsultaPagosConvenioService 
{
    constructor(public http: HttpClient, ) { }

    postulacionesDisponibles(usuario: any,rol:any){
        return this.http.get(`${environment.urlApiPrestamo}/postulacionesDisponibles/${usuario}/rol/${rol}`, 
        { headers: this.armaCabecera() }).toPromise();
    }

    pagosDisponiblesBuscador(usuario: any,rol:any,buscador:any,email:any){
      
        return this.http.post(`${environment.urlApiPrestamo}/pagosDisponiblesConvenio/buscador/`,
        {
            id:usuario,
            email: email,
            rol:rol,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idSolicitud: buscador?.idSolicitud,
            idRegion: buscador?.region,
            rut: buscador?.rut,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            estado: buscador?.estado
        }, 
        { headers: this.armaCabecera() }).toPromise();
    }
    traePagosBuscador(usuario:any,buscador:any){
        return this.http.post(`${environment.urlApiPrestamo}/pagos/convenio/buscador/`,
        {
            id:usuario,            
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idSolicitud: buscador?.idSolicitud,
            rut: buscador?.rut,
            idRegion: buscador?.region,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            estado: buscador?.estado
        }, 
        { headers: this.armaCabecera() }).toPromise();
    }
    postulacionesDisponiblesBuscador(usuario: any,rol:any,buscador:any,email:any){
        return this.http.post(`${environment.urlApiPrestamo}/pagosDisponibles/buscador/`,
        {
            id:usuario,
            email: email,
            rol:rol,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idSolicitud: buscador?.idSolicitud,
            rut: buscador?.rut,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            estado: buscador?.estado
        }, 
        { headers: this.armaCabecera() }).toPromise();
    }
    traePostulacionesAsignadas(usuario:any,buscador:any){
        return this.http.post(`${environment.urlApiPrestamo}/pagos/convenio/asignados/ejecutivos/id/`,
        {
            idUsuario: usuario,
            idUsuarioAsig: usuario,
            idSolicitud: buscador?.idSolicitud,
            rut: buscador?.rut,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            estado: buscador?.estado,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage
        },
        { headers: this.armaCabecera() }).toPromise();
    }
    traeUsuario(rut: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/afiliados/rut/${rut}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    buscarPago(idPlanPago: any){
        return this.http.post(`${environment.urlApiPrestamo}/pagos/convenio/buscar/${idPlanPago}`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    traeTipoPrestamo(){
        
        return this.http.get(`${environment.urlApiPrestamo}/getTipoPrestamo`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    guardarEdicion(prestamo:any){
      
        return this.http.post(`${environment.urlApiPrestamo}/prestamo/guardar`,
        {
            
            idCarga:0,
            idProducto: 4,
            idPostulacion: prestamo.idPostulacion,
            prestamo:  {
                montoSolicitado: prestamo.montoSolicitado,
                cantidadCuota:prestamo.cantidadCuotas,
                tipoPrestamo:prestamo.tipoPrestamo,
                totalCuota:prestamo.montoCuota,
                idPrestamo:prestamo.idPrestamo,
                fechaPrimerPago:prestamo.fechaPrimerPago,
                idPostulacion: prestamo.idPostulacion,
                tasaInteres:(prestamo.planes[0].montoTotalCuota-prestamo.planes[0].montoCuota),
                 montoCuota: prestamo.planes[0].montoCuota,
                planes: prestamo.planes
                 }
             
            
          //  notificacion: { email:escolaridad.email, nombreCompleto:nombreUsuario, nombreProducto: 'PRESTAMO' }

        },

        { headers: this.armaCabecera() }).toPromise();
    }
  
    motivoRechazo(idProducto: any)
    {
        return this.http.get(`${environment.urlApiPrestamo}/motivoRechazo/productos/${idProducto}/`,
               { headers:this.armaCabecera() }).toPromise()
    }
    traeArchivos(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/archivo-adjunto/`,
               { headers:this.armaCabecera() }).toPromise()
    }
    cambiarEstadoPostulacion(idPostulacion: any, estado: any)
    {
        return this.http.post(`${environment.urlApiPrestamo}/solicitudes/`,
               { id: idPostulacion, estado: estado }, { headers:this.armaCabecera() } ).toPromise();
    }
    traePrestamo(id: any,mostrarEditar:any){
       
        return this.http.get(`${environment.urlApiPrestamo}/prestamo/${id}`, 
        { headers: this.armaCabecera() }).toPromise();
    }
    traePostulantes(rut: any)
    {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`, 
               { headers: this.armaCabecera() }).toPromise();
    }
    asignaPostulacion(postulaciones: any, idEjecutivo: any)
    {
        return this.http.post(`${environment.urlApiPrestamo}/pagos/asignar/ejecutivo/${idEjecutivo}`,
        postulaciones, { headers:this.armaCabecera() } ).toPromise()
    }
    traeRegiones()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/regiones`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeEstados()
    {
        return this.http.get(`${environment.urlApiPrestamo}/convenio/estadosSubsidios`,
        { headers:this.armaCabecera() }).toPromise();
    }
    rechazarSerCodeudor(prestamo:any, idCodeudor: any,resultado:any){
        return this.http.post(`${environment.urlApiPrestamo}/solicitud/codeudor/rechazar`,
        {   idPostulacion:prestamo.idPostulacion,
            idPrestamo:prestamo.idPrestamo,
            idCodeudor:idCodeudor,
            prestamo:{ idPostulacion:prestamo.idPostulacion,
                        idPrestamo:prestamo.idPrestamo,
                        idUsuario: idCodeudor}
        }
        ,{ headers:this.armaCabecera() }).toPromise();
    }
    aprobarSerCodeudor(prestamo:any,archivo:any, idCodeudor: any,resultado:any){
        
        return this.http.post(`${environment.urlApiPrestamo}/solicitud/codeudor/aprobar`,
        {      idPostulacion:prestamo.idPostulacion,
            idPrestamo:prestamo.idPrestamo,
            idCodeudor:idCodeudor,
            prestamo:{ idPostulacion:prestamo.idPostulacion,
                        idPrestamo:prestamo.idPrestamo,
                        idUsuario: idCodeudor},
            archivoAdjunto: [ { url: "", archivo: archivo.archivo, extension:archivo.extension } ]
        }
        ,{ headers:this.armaCabecera() }).toPromise();

    }
   
    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}